import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { getOrderData } from 'redux/actions';
import { LoadingSection, Section } from './components';

const OrderPage = () => {
    let { id } = useParams();

    const dispatch = useDispatch();
    const { order, loading } = useSelector((state) => state.orders);
    // const loading = true;

    useEffect(() => {
        dispatch(getOrderData(id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, id]);
    // eslint-disable-next-line react-hooks/exhaustive-deps

    return loading ? <LoadingSection /> : <Section id={id} order={order} />;
};

export default OrderPage;
